import "../../../../content/projects/aag/aag.css";
import * as React from 'react';
export default {
  React
};